const LEAVE_HISTORY_ACTIONS = {
  //get leave history
  GET_LEAVE_HISTORY_BY_TOKEN: "GET_LEAVE_HISTORY_BY_TOKEN",
  GET_LEAVE_HISTORY_BY_TOKEN_SUCCESS: "GET_LEAVE_HISTORY_BY_TOKEN_SUCCESS",
  GET_LEAVE_HISTORY_BY_TOKEN_FAIL: "GET_LEAVE_HISTORY_BY_TOKEN_FAIL",
  //get leave history detail
  GET_LEAVE_HISTORY_DETAIL_BY_TOKEN: "GET_LEAVE_HISTORY_DETAIL_BY_TOKEN",
  GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_SUCCESS:
    "GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_SUCCESS",
  GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_FAIL:
    "GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_FAIL",
};
export default LEAVE_HISTORY_ACTIONS;
